import { authStore } from '@/services/auth/store';
import { crossAppCache } from '@/utils/cross-app-cache';
import { hydraUiApi } from '@/services/api';
import { useStore } from '@nanostores/react';
import { useEffect, useRef } from 'react';

/**
 * Preload workspace data for use on Journeys, aimed at
 * improving app initialization time.
 */
export function usePreloadWorkspaceData() {
  const { account, user, workspaces } = useStore(authStore);
  const hasAttemptedWorkspacePreload = useRef<boolean>(false);

  useEffect(
    function preloadWorkspaceData() {
      if (account != null && user != null && workspaces != null && !hasAttemptedWorkspacePreload.current) {
        hasAttemptedWorkspacePreload.current = true;

        const lastCioWorkspaceId = user.last_cio_workspace_id;

        void hydraUiApi.environments
          .get({ params: { path: { environment_id: String(lastCioWorkspaceId) } } })
          .then((data) => {
            // Sanity check to avoid caching invalid data
            if (data?.environment?.id != null) {
              crossAppCache.setValue({
                key: `/environments/${lastCioWorkspaceId}`,
                value: data,
                ttl: 10000,
                cacheOnlyOnce: true,
              });
            }
          });
      }
    },
    [user, workspaces, account],
  );
}
